import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";
import { HTS_ISOLATED_OLD_INCIDENT_NOTE } from "./sharedNotes";

export const personalConductHistory: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.PERSONAL_CONDUCT_HISTORY,
  label: "Conduct and personal history",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what happened",
    "when it happened",
    "whether it was an isolated incident or part of a pattern",
    "how it was resolved",
    "what changed since",
  ],
  followUpTriggers: [
    "it's unclear whether the incident was isolated or recurring",
    "a self-defence or provocation claim isn't backed by any detail",
    "the timeline is unclear",
  ],
  hardBarrierFacts: [
    "a pattern of physical altercations, rather than a single old, isolated incident",
    "a protection order, peace bond, or family-violence-related police involvement confirmed to be recent or repeated",
  ],
  // The doc is explicit that protection-order/family-violence disclosures are
  // "handled with the candidate's exact words rather than AI commentary" —
  // the flag note quotes rather than paraphrases/interprets for this category.
  noteStyle: "verbatim-quote",
  crossCuttingNotes: [
    HTS_ISOLATED_OLD_INCIDENT_NOTE,
    "protection order / peace bond / family-violence police involvement is at minimum a standard flag once ever disclosed — only escalate to the hard-barrier recent-or-repeated threshold above once that's actually confirmed",
    "problem gambling (financial or personal problems caused by gambling) feeds the finances picture — an ongoing problem gets flagged",
  ],
};
